interface Props {
    reason: string;
}

const AMENDMENT_REASON_OPTIONS: Array<{ value: string; label: string }> = [
    { value: 'renegotiation', label: 'Renegociação' },
    { value: 'restructuring', label: 'Reestruturação' },
    { value: 'not_applicable', label: 'N/A' },
];

/**
 * Exibe (somente leitura) o motivo do aditamento, no mesmo padrão visual da
 * Configuração de cobrança. Deve ser renderizado apenas quando o contrato tem
 * origem em aditamento.
 */
const AmendmentReasonSection: React.FC<Props> = ({ reason }) => {
    return (
        <>
            <h3 className="text-md font-semibold mt-4 mb-3 text-gray-700 dark:text-gray-200">Motivo do Aditamento</h3>
            <div className="grid grid-cols-12 gap-4 mb-6" role="group" aria-label="Motivo do aditamento">
                <fieldset className="col-span-12">
                    <div className="flex items-center gap-6">
                        {AMENDMENT_REASON_OPTIONS.map(({ value, label }) => (
                            <label key={value} className="flex items-center gap-1.5 opacity-100 cursor-not-allowed">
                                <input
                                    type="radio"
                                    name="amendment_reason_view"
                                    checked={reason === value}
                                    disabled
                                    readOnly
                                    aria-label={label}
                                    className="w-4 h-4 text-purple-600 dark:text-purple-400"
                                />
                                <span className={`text-sm font-medium ${reason === value ? 'text-purple-600 dark:text-purple-400 font-bold' : 'text-gray-700 dark:text-gray-300'}`}>
                                    {label}
                                </span>
                            </label>
                        ))}
                    </div>
                </fieldset>
            </div>
        </>
    );
};

export default AmendmentReasonSection;
